module.exports = __webpack_public_path__ + "static/landingbuilder-1-fd95fdf1a6cb52698537a83061d41045.png";